import { Typography } from "@mui/material";

import {
  type ArticleListItem,
  normalizeArticleListItem
} from "@/src/utils/blogUtils";

import ArticleExternalTextLink from "./ArticleExternalTextLink";

interface ArticleListItemContentProps {
  item: ArticleListItem;
  itemKey: string;
}

const ArticleListItemContent = (props: ArticleListItemContentProps) => {
  const { item, itemKey } = props;

  return normalizeArticleListItem(item).map((part, idx) => {
    if (part.kind === "ArticleLink") {
      return (
        <ArticleExternalTextLink
          key={`${itemKey}-link-${idx}`}
          url={part.url}
          text={part.text}
        />
      );
    }

    if (part.kind === "ArticleParagraphText") {
      return (
        <Typography
          component="span"
          variant="body1"
          key={`${itemKey}-text-${idx}`}
        >
          {part.value}
        </Typography>
      );
    }

    return null;
  });
};

export default ArticleListItemContent;
